/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default class PageBody extends Component {
    render() {
        return (
            <div id="page-body" className={this.props.className}>
                {this.props.children}
            </div>
        );
    }
}

PageBody.propTypes = propTypes;
